import { ZfIconButton } from '@zafire/react';
import type { ICellRendererParams } from 'ag-grid-enterprise';
import type { FunctionComponent } from 'react';
import { useMemo } from 'react';
import { WRITABLE_CATEGORIES_CLM } from '../../../config/constants';
import { WealthOverviewEntrySource } from '../../../enums';
import type { BalanceSheetTableData } from '../../../interfaces/balance-sheet-table';

export const BalanceSheetTableActionCell: FunctionComponent<ICellRendererParams<BalanceSheetTableData>> = ({ data }) => {
    const isEditableEntry = useMemo(
        () => data?.qualifiedId && data?.qualifiedId.source === WealthOverviewEntrySource.PCM_CORE && WRITABLE_CATEGORIES_CLM.includes(data.categoryId),
        [data],
    );

    if (!data) return null;

    if (data.isCategoryTitle)
        return WRITABLE_CATEGORIES_CLM.includes(data.categoryId) ? (
            <ZfIconButton
                hierarchy="tertiary"
                size="extra-small"
                icon="add_circle"
                style={{ display: 'flex', alignItems: 'center' }}
                onClick={() => data.onRowActionClick({ categoryId: data.categoryId ?? '' })}
            />
        ) : null;

    return (
        <div>
            <ZfIconButton
                hierarchy="tertiary"
                size="extra-small"
                icon={isEditableEntry ? 'edit' : 'visibility'}
                style={{ display: 'flex', alignItems: 'center' }}
                onClick={() => data.onRowActionClick({ balanceEntry: { ...data }, categoryId: data.categoryId! })}
            />
        </div>
    );
};
